<template>
  <div
    class="page-container">
    <Navbar
      @open-sidebar="sidebar = true" />
    <Sidebar
      v-model="sidebar" />
    <RouterView 
      v-if="layoutAlive"
      class="main-container"/>
    <ToTop />
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import Sidebar from './Sidebar/index.vue'
import ToTop from './ToTop.vue'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      sidebar: false
    }
  },
  computed: {
    ...mapGetters(['layoutAlive'])
  },
  components: {
    Navbar,
    Sidebar,
    ToTop
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  padding-top: 4rem;
  background-color: #F0F2F5;
  min-height: var(--inner-height);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.navbar{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: #fff;
}
.main-container{
  flex: 1;
  padding: .8rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss">
@import '@/assets/styles/layout.scss'
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue